import {
    ButtonPrimary,
    ButtonFixedFooterLayout,
    Text3,
    Text2,
    RadioGroup,
    BoxedRow,
    RadioButton,
    EmptyState,
    skinVars,
    IconListRegular,
    useWindowSize,
    Text1,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { getCustomerAccounts } from '../../../../services/CustomerService';
import { hideSpinner } from '../../../../utils/store/features/user';
import { formatMobileNumber } from '../../../../utils/dataTransformation/unitsConversion';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import useUserlight from '../../../../hooks/useUserLight';
import { CustomerAccount } from '../../../../models/Customer';
import { AxiosResponse } from 'axios';
import HeaderProfile from '../../../../components/HeaderProfile';
import { useNavigate } from 'react-router-dom';

export const SelectBankAccount: React.FC = () => {
    const { t } = useTranslation();
    const isLight = useUserlight();
    sessionStorage.removeItem('pathOrigin');
    const { trackingScreenView } = new TrackingEvents();
    const dispatch = useDispatch();
    const valueSelectedBefore: any = sessionStorage.getItem('valueSelected');
    const size = useWindowSize();
    const navigate = useNavigate();
    const [accounts, setAccounts] = useState<CustomerAccount[]>();
    const [valueSelected, setValueSelected] = useState<any>(valueSelectedBefore ? valueSelectedBefore : '');

    useEffect(() => {
        if (!isLight) getInfoCostumerAccounts();
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    const setStorage = (description?: string, err?: any) => {
        let accountSelected: CustomerAccount = {
            id: '',
            number: '',
            legalEntity: '',
            productNumbers: [],
            iban: '',
        };
        accounts?.map((item: CustomerAccount) => {
            if (valueSelected === item.id) {
                accountSelected = item;
            }
        });

        return { state: description, err: err ? err : '', account: accountSelected };
    };

    const handleNavigate = (url: string) => {
        localStorage.setItem('storage', JSON.stringify(setStorage()));
        navigate(url);
    };

    const getInfoCostumerAccounts = () => {
        getCustomerAccounts()
            .then((response: AxiosResponse) => {
                setAccounts(response.data);
                dispatch(hideSpinner());
            })
            .catch(() => {
                dispatch(hideSpinner());
            });
    };

    return (
        <div className='changeBankAccount-page'>
            {accounts?.length === 0 || null ? (
                <>
                    <EmptyState
                        asset={<IconListRegular color={skinVars.colors.brand} size={64} />}
                        title={'Title empty state'}
                        description={'Description Empty State'}
                    ></EmptyState>
                </>
            ) : (
                <>
                    <div
                        className='updatePassword-page__header'
                        style={{ borderBottom: size.width >= 1024 ? `1px solid ${skinVars.colors.divider}` : '' }}
                    >
                        <HeaderProfile
                            title={t('supportContentRowChangeBankAccount')}
                            breadcrumbs={[
                                { title: t('profileTitle'), url: '/profile' },
                                { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                            ]}
                        />
                    </div>

                    {size.width >= 768 ? (
                        <div className='changeBankAccount-page__content'>
                            {size.width >= 1024 && (
                                <div className='changeBankAccount-page__content-title'>
                                    <Text1 medium color={skinVars.colors.textSecondary}>
                                        {t('bankAccountTitle')}
                                    </Text1>
                                </div>
                            )}

                            <div className='changeBankAccount-page__content-subTitle'>
                                <Text3 regular color={skinVars.colors.textPrimary}>
                                    {t('profileChangeBankAccountText1')}
                                </Text3>
                            </div>
                            <RadioGroup name={''} value={valueSelected} onChange={setValueSelected}>
                                <div className='changeBankAccount-page__content__rows'>
                                    {accounts?.map((item: any, index: number) => {
                                        return (
                                            <div
                                                className='pchangeBankAccount-page__content__rows-boxedRow'
                                                key={index}
                                                onClick={() => setValueSelected(item.id)}
                                            >
                                                <BoxedRow
                                                    key={index}
                                                    title={''}
                                                    extra={
                                                        <div className='changeBankAccount-page__content__rows__extra'>
                                                            <div>
                                                                <div className='changeBankAccount-page__content__rows__extra__type'>
                                                                    <Text3 regular>
                                                                        {t('last4charactersText')}
                                                                        {item.number.substring(item.number.length - 4)}
                                                                    </Text3>
                                                                </div>
                                                                {item.productNumbers.map((num: any, index: any) => {
                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            className='changeBankAccount-page__content__rows__extra__numbers'
                                                                        >
                                                                            <Text2
                                                                                regular
                                                                                color={skinVars.colors.textSecondary}
                                                                            >
                                                                                {formatMobileNumber(num)}
                                                                            </Text2>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    }
                                                    right={
                                                        <div className='changeBankAccount-page__content__rows__radio'>
                                                            <RadioButton value={item.id} />
                                                        </div>
                                                    }
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            </RadioGroup>
                            <div className='changeBankAccount-page__content-buttonPrimary'>
                                <ButtonPrimary
                                    disabled={valueSelected === ''}
                                    onPress={() => {
                                        handleNavigate('/update-bank-account');
                                    }}
                                >
                                    {t('next')}
                                </ButtonPrimary>
                            </div>
                        </div>
                    ) : (
                        <ButtonFixedFooterLayout
                            button={
                                <ButtonPrimary
                                    onPress={() => {
                                        handleNavigate('/update-bank-account');
                                    }}
                                    disabled={valueSelected === ''}
                                >
                                    {t('next')}
                                </ButtonPrimary>
                            }
                        >
                            <div className='changeBankAccount-page__content'>
                                <div className='changeBankAccount-page__content-subtitle'>
                                    <Text3 regular color={skinVars.colors.textPrimary}>
                                        {t('profileChangeBankAccountText1')}
                                    </Text3>
                                </div>
                                <RadioGroup name={''} value={valueSelected} onChange={setValueSelected}>
                                    <div className='changeBankAccount-page__content__rows'>
                                        {accounts?.map((item: any, index: number) => {
                                            return (
                                                <div
                                                    className='changeBankAccount-page__content__rows-boxedRow'
                                                    key={index}
                                                    onClick={() => setValueSelected(item.id)}
                                                >
                                                    <BoxedRow
                                                        key={index}
                                                        title={''}
                                                        extra={
                                                            <div className='changeBankAccount-page__content__rows__extra'>
                                                                <div>
                                                                    <div className='changeBankAccount-page__content__rows__extra__type'>
                                                                        <Text3 regular>
                                                                            {t('last4charactersText')}
                                                                            {item.number.substring(
                                                                                item.number.length - 4,
                                                                            )}
                                                                        </Text3>
                                                                    </div>

                                                                    {item.productNumbers.map((num: any, index: any) => {
                                                                        return (
                                                                            <div
                                                                                key={index}
                                                                                className='changeBankAccount-page__content__rows__extra__numbers'
                                                                            >
                                                                                <Text2
                                                                                    regular
                                                                                    color={
                                                                                        skinVars.colors.textSecondary
                                                                                    }
                                                                                >
                                                                                    {formatMobileNumber(num)}
                                                                                </Text2>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        }
                                                        right={
                                                            <div className='changeBankAccount-page__content__rows__radio'>
                                                                <RadioButton value={item.id} />
                                                            </div>
                                                        }
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </RadioGroup>
                            </div>
                        </ButtonFixedFooterLayout>
                    )}
                </>
            )}
        </div>
    );
};

export default SelectBankAccount;
